"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustoms = void 0;
var _constants = require("./constants");
const getCustoms = props => {
  return {
    BG_COLOR: props.bgColor || _constants.DEFAULT_BG_COLOR
  };
};
exports.getCustoms = getCustoms;